import { Map } from 'immutable';

import {
  ACTIVATE_SITE,
  CLONE_SITE_CONFIGURATION,
  CREATE_SITE,
  DEACTIVATE_SITE,
  DELETE_SITE,
  EDIT_SITE,
  RECEIVE_SITES,
  REMOVE_SITES,
  REQUEST_SITE_ANCESTRY,
  REQUEST_SITE_GROUP_SITES,
  SEED_SITE_CONTEXT,
} from '@sophocles/entities/Site/siteActions';
import { Site } from '@sophocles/entities/Site/siteRecord';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SITES:
      return state.merge(action.sites);
    case SEED_SITE_CONTEXT:
      // Per-key set (not Record.merge): merge deep-converts plain arrays to
      // Lists, diverging from the plain values RECEIVE_SITES stores.
      return state.update(action.siteId, existing =>
        Object.entries(action.fields).reduce((rec, [key, value]) => rec.set(key, value), existing ?? Site()),
      );
    case DELETE_SITE:
      return state.delete(action.site);
    case REQUEST_SITE_GROUP_SITES:
    case EDIT_SITE:
    case CREATE_SITE:
    case REQUEST_SITE_ANCESTRY:
    case DEACTIVATE_SITE:
    case ACTIVATE_SITE:
    case CLONE_SITE_CONFIGURATION:
    default:
      return state;
  }
}

export function siteReducer(state = Map(), action) {
  switch (action.type) {
    case REMOVE_SITES:
      return Map();
    case DELETE_SITE:
    case RECEIVE_SITES:
    case SEED_SITE_CONTEXT:
    case REQUEST_SITE_GROUP_SITES:
    case EDIT_SITE:
    case CREATE_SITE:
    case REQUEST_SITE_ANCESTRY:
    case DEACTIVATE_SITE:
    case ACTIVATE_SITE:
    case CLONE_SITE_CONFIGURATION:
      return getState(state, action);
    default:
      return state;
  }
}
